import ToppingOrderItem from '../ToppingOrderItem/topping-order-item';

export default ToppingOrderItem;